import { LAYOUT_TYPE, Menu, PathInfo } from "types/general.types"
import MENUS, { ITEM_VIEW_PAGES } from "constants/pages"
import { Android, BlackBerry, iOS, Linux, Mac, MAIN_LAYOUT, Unix, Windows } from "constants/index"

const DEFAULT_PATH_VALUES: Omit<PathInfo, keyof Menu> & Required<PathInfo> = {
  path: "",
  key: "",
  title: "",
  icon: null,
  selectedIcon: null,
  headerButtons: null,
  showInNavigation: false,
  orderInNavigation: 0,
  useLayoutWithPadding: false,
  hasBackButton: false,
  customBackButtonEvent: null,
  isProtected: false,
  component: null,
  dynamicPathParts: null,
  layoutType: MAIN_LAYOUT as LAYOUT_TYPE
}

export const PATH_INFOS: Record<string, PathInfo> = Object.keys(MENUS).reduce(
  (acc, key) => {
    const menuKey = key as keyof typeof MENUS
    acc[key] = convertMenuToPathInfo(MENUS[menuKey])
    return acc
  },
  {} as Record<string, PathInfo>
)

function convertMenuToPathInfo(menu: Menu): PathInfo {
  return {
    ...DEFAULT_PATH_VALUES,
    ...menu
  }
}

export function getCurrentPathInfo(path: string): PathInfo | undefined {
  if (!path) {
    console.error(`invalid path in getCurrentPathInfo. path: ${path}`)
    return undefined
  }

  const nonPublicPath = path.replace("/public", "")
  const cleanedPath = normalizePath(nonPublicPath)
  const pathSegments = getPathSegments(cleanedPath)

  if (pathSegments.length === 0) {
    return PATH_INFOS.landing
  }

  return matchRoute(pathSegments, PATH_INFOS)
}

function normalizePath(path: string): string {
  return path.endsWith("/") ? path.slice(0, -1) : path
}

function getPathSegments(path: string): string[] {
  return path.split("/").filter(Boolean)
}

function matchRoute(pathSegments: string[], routes: { [key: string]: PathInfo }): PathInfo | undefined {
  for (let r in routes) {
    const route = routes[r]
    const routeSegments = getPathSegments(route.path)

    if (routeSegments.length === pathSegments.length) {
      let pathParams: any = {}
      let isMatch = true

      for (let i = 0; i < routeSegments.length; i++) {
        const routeSegment = routeSegments[i]

        if (routeSegment.startsWith(":")) {
          const paramName = routeSegment.slice(1) // Remove ":"
          pathParams[paramName] = pathSegments[i]
        } else if (routeSegment !== pathSegments[i]) {
          isMatch = false
          break
        }
      }

      if (isMatch) {
        return { ...route, dynamicPathParts: pathParams }
      }
    }
  }
}

export function getOS() {
  var uA = navigator.userAgent
  if ((/iPad|iPhone|iPod/.test(uA)) || (uA.includes("Mac") && "ontouchend" in document)) return iOS

  var i, os = [Windows, Android, Unix, Mac, Linux, BlackBerry]
  for (i = 0; i < os.length; i++) if (new RegExp(os[i], "i").test(uA)) return os[i]
}

export function isRunningStandalone() {
  return window.matchMedia("(display-mode: standalone)")?.matches || (window?.navigator as any)?.standalone === true
}

export function isItemViewPage(path: string) {
  return ITEM_VIEW_PAGES.includes(path)
}

export function extractStaticPart(endpoint: string) {
  const match = endpoint.match(/^(.*?)(?=:[^/]+$)/)
  return match ? match[1] : endpoint
}
